<script setup>
import {ref, computed} from 'vue'
import {useAssumeUserStore} from '@/stores/assumeUser'
import {useUserStore} from '@/stores/user'

const props = defineProps({
    item: Object
})

// Pinia Stores
const assumeUserStore = useAssumeUserStore()
const userStore = useUserStore()

const enabled = ref(false)

const user = computed(() => {
    return userStore.user
})

// Remove the button if the user is not an administrator or it's the current user's row.
if (user.value) {
    enabled.value = (
        user.value.administrator &&
        user.value.id !== props.item?.id
    )
}

const assumeUser = () => {
    assumeUserStore.assume(props.item.id)
}
</script>

<template>
    <button v-if="enabled" class="btn btn-light btn-sm" type="button" @click="assumeUser">
        assume
    </button>
</template>